<template>
  <v-dialog
    eager
    width="500"
    v-model="dialog"
  >
    <v-card>
      <v-card-title>
        <v-col class="text-right px-4">
          <v-btn icon @click="dialog=false">
            <v-icon large color="primary">close</v-icon>
          </v-btn>
        </v-col>
      </v-card-title>

      <v-card-text>
        <v-row justify="space-around">
          <v-col cols="12">
            <!-- Elevator -->
            <v-text-field
              outlined
              disabled
              v-model="elevatorName"
              :label="$t('display/logs:email-log.elevator-name')"
            />
            <!-- Elevator -->
            <v-text-field
              outlined
              disabled
              v-model="currentItem.createdAt"
              :label="$t('display/logs:email-log.emergency-time')"
            />
            <!-- Elevator -->
            <v-text-field
              outlined
              disabled
              v-model="currentItem.to"
              :label="$t('common:email')"
            />
            <!-- Elevator -->
            <v-text-field
              outlined
              disabled
              v-model="currentItem.subject"
              :label="$t('display/logs:email-log.subject')"
            />
            <!-- Elevator -->
            <v-textarea
              outlined
              readonly
              v-model="currentItem.body"
              :label="$t('display/logs:email-log.message')"
            />
            <!-- Elevator -->
            <v-textarea
              outlined
              readonly
              v-model="currentItem.result"
              :label="$t('common:status')"
            />
          </v-col>
        </v-row>

      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          @click="dialog = false"
        >
          {{ $t('buttons:close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "DetailInfoWindow",
  data() {
    return {
      currentItem: {},
      dialog: false,
      data: '',
      elevatorName: ''
    }
  },
  methods: {
    initialization(item) {
      this.elevatorName = '';
      this.currentItem = item;
      this.dialog = true;

      if (item.emergency !== null) {
        this.elevatorName = item.emergency.elevator.name;
      }
    }
  }
}
</script>